<div class="panel detail-panel error" *ngIf="errors?.length > 0">
  <div class="panel-body container">
    <h5><i class="fa fa-exclamation-triangle"></i> {{ 'order.errorMessage' | translate }}</h5>
    <ul class="block">
      <li *ngFor="let el of errors">
        <span class="code">
          <a [routerLink]="'/product/' + el.productCode">{{ el.productCode }}</a> :
        </span>
        {{ el.reason }}
      </li>
    </ul>
  </div>
</div>

<div class="container">
<!-- <div class="container-order-summary"> -->
<div class="columns container-order-summary">

  <div class="ctn-detail-panel">
    <div class="column col-3 col-2x-3 col-lg-12 col-xs-12 col-gapless panel detail-panel">
      <!-- Numéro de commande -->
      <div class="panel-header text-center">
        <h4 class="panel-title h4"><span class="text-highlight text-bold">></span> {{ 'order.label' | translate }} {{ order?.code }}</h4>
        <div class="panel-subtitle">{{ 'order.dateLabel' | translate}} : {{ order?.date | stringToDate:'dd/MM/yyyy' }}</div>
      </div>

      <div class="panel-body container">
        <!-- Date de livraison -->
        <div class="container-panel-info">
          <div class="panel-label">{{ 'order.deliveryDate' | translate }}</div>
          <div class="panel-data">{{ order?.deliveryDate | stringToDate:'dd/MM/yyyy' }}</div>
        </div>

        <div class="container-panel-info">
          <!-- Adresse de livraison -->
          <div class="panel-label">{{ 'address.delivery' | translate }}</div>
          <div class="panel-data">
            <address>
              <ng-container *ngIf="order?.deliveryAddress.name">
                {{ order?.deliveryAddress.name }}<br />
              </ng-container>
              <ng-container *ngIf="order?.deliveryAddress.address1">
                {{ order?.deliveryAddress.address1 }}<br />
              </ng-container>
              <ng-container *ngIf="order?.deliveryAddress.address2">
                {{ order?.deliveryAddress.address2 }}<br />
              </ng-container>
              <ng-container *ngIf="order?.deliveryAddress.address3">
                {{ order?.deliveryAddress.address3 }}<br />
              </ng-container>
              <ng-container *ngIf="order?.deliveryAddress.zipCode || order?.deliveryAddress.city">
                {{ order?.deliveryAddress.zipCode }} {{ order?.deliveryAddress.city }}<br />
              </ng-container>
              <ng-container *ngIf="order?.deliveryAddress.address3">
                {{ order?.deliveryAddress.country }}
              </ng-container>
            </address>
          </div>

          <!-- Atteinte franco -->
          <ng-container *ngIf="order?.price.freeDeliveryRemaining || order?.price.freeDeliveryRemaining === ''">
            <div class="container-panel-info">
              <div class="panel-label">{{ 'price.freeDeliveryRemaining' | translate }}</div>
              <div class="panel-data">
                <span *ngIf="order?.price.freeDeliveryRemaining != ''">{{ order?.price.freeDeliveryRemaining }} {{ order?.price.unit }}</span>
                <span *ngIf="order?.price.freeDeliveryRemaining === ''">{{ 'price.freeDeliveryReached' | translate }}</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="orderTypeLabel">
            <div class="flex">
              <!-- Type de commande -->
              <!-- <div class="container-panel-info">
                <div class="panel-label">{{ 'order.orderType' | translate }}</div>
                <div class="panel-data"><span>{{ orderTypeLabel }}</span></div>
              </div> -->

              <!-- Nombre d'article -->
              <div class="container-panel-info">
                <div class="panel-label">{{ 'order.count' | translate }}</div>
                <div class="panel-data">
                  <span>{{ order?.count }} {{ (order?.count > 1 ? 'order.countPlural' : 'order.countSingular') | translate }}</span>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container>
            <div class="flex">
              <!-- Statut de la commande -->
              <div class="container-panel-info" *ngIf="order?.status">
                <div class="panel-label">{{ 'order.statusLabel' | translate}}</div>
                <div class="panel-data">
                  <span class="status">{{ order.statusLabel }}</span>
                </div>
              </div>

              <!-- Référence commande client -->
              <div class="container-panel-info" *ngIf="order?.customCode">
                <div class="panel-label">{{ 'order.customCode' | translate }}</div>
                <div class="panel-data">{{ order?.customCode }}</div>
              </div>
            </div>
          </ng-container>

          <ng-container>
            <div class="flex">
              <!-- Frais de port -->
              <!--<div class="container-panel-info" *ngIf="isFrancoAtteint()">
                <div class="panel-label">{{ 'order.shippingFees' | translate }} ({{ 'header.reachedClassicFranco' | translate }})</div>
                <div class="panel-data"><del>25 €</del> 0 €</div>
              </div>

              <div class="container-panel-info" *ngIf="!isFrancoAtteint()">
                <div class="panel-label">{{ 'order.shippingFees' | translate }}</div>
                <div class="panel-data">25 €</div>
              </div>-->
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Boutons de commande et infos franco -->
      <div>

        <div class="ctn-francos">
          <app-franco class="app-franco" *ngIf="contextService.fullContext?.customer?.isFrancoUnique"
            [isFrancoUnique]="contextService.fullContext?.customer?.isFrancoUnique"
            [isFrancoAmenage]="contextService.fullContext?.customer?.isFrancoAmenage"
            [contextOrder]="contextOrder" [contextFranco]="contextFranco" [showFeeAmount]="true"></app-franco>
        </div>

        <div class="flex container-btn" *ngIf="order?.status === orderStatus.CREATED || order?.status === orderStatus.UPDATED">
          <!-- Continuer les achats -->
          <button class="btn btn-primary" (click)="continueOrder()">
            <i class="fa fa-cart-plus"></i> {{ 'buttons.continueOrder' | translate }}
          </button>

          <!-- Valider la commande -->
          <button class="btn btn-success" (click)="validateOrder()">
            <i class="fa fa-check"></i> {{ 'buttons.validateOrder' | translate }}
          </button>

          <!-- Annuler la commande -->
          <button class="btn btn-error" (click)="cancelOrder()">
            <i class="fa fa-times"></i> {{ 'buttons.cancelOrder' | translate }}
          </button>
        </div>

        <div class="flex container-btn" *ngIf="order?.status === orderStatus.INACTIVE" [ngClass]="{'tooltip': !validatedTerms}" [attr.data-tooltip]="'order.validatedTermsTooltip' | translate">
          <!-- Réactiver la commande -->
          <button [disabled]="!validatedTerms" class="btn btn-primary" (click)="reactivateOrder()">
            <i class="fa fa-cogs"></i> {{ 'buttons.reactivateOrder' | translate }}
          </button>
        </div>

      </div>

      <div id="orderSummaryAdditionnalInfos" class="panel-body container" *ngIf="showOrderSummaryAdditionnalInfos">
        <div class="flex">
            <!-- Prix net -->
            <ng-container *ngIf="order?.price.totalAfterTaxes">
              <div class="container-panel-info">
                <div class="panel-label">{{ 'product.prices.net' | translate }}</div>
                <div class="panel-data">
                    <span>{{ order?.price.totalAfterTaxes }} {{ order?.price.unit }} {{ 'product.prices.inclVAT' | translate }}</span>
                </div>
              </div>
            </ng-container>
            <!-- Poids net -->
            <ng-container *ngIf="order?.weight?.net">
              <div class="container-panel-info">
                <div class="panel-label">{{ 'weight.net' | translate }}</div>
                <div class="panel-data">{{ order?.weight?.net + order?.weight?.unit }}</div>
              </div>
            </ng-container>
            <!-- Poids unitaire -->
            <ng-container *ngIf="order?.weight?.gross">
              <div class="container-panel-info">
                <div class="panel-label">{{ 'weight.gross' | translate }}</div>
                <div class="panel-data">{{ order?.weight?.gross + order?.weight?.gross }}</div>
              </div>
            </ng-container>
            <!-- Type de palette -->
            <ng-container *ngIf="order?.palletType">
              <div class="container-panel-info">
                <div class="panel-label">{{ 'order.palletType' | translate }}</div>
                <div class="panel-data">{{ order?.palletType }}</div>
              </div>
            </ng-container>
            <!-- Taux de remplissage des palettes -->
            <ng-container *ngIf="order?.palletFillRate">
              <div class="container-panel-info">
                <div class="panel-label">{{ 'order.palletFillRate' | translate }}</div>
                <div class="panel-data">{{ order?.palletFillRate }}</div>
              </div>
            </ng-container>
        </div>
      </div>

      <!-- Bouton Informations complémentaires -->
      <div class="panel-button-seemore">
        <a class="link-info-supp" type="" (click)="toggleInfos()"
                *ngIf="order?.price.totalAfterTaxes || order?.weight?.net || order?.weight?.gross || order?.palletType || order?.palletFillRate">
            Informations complémentaires
        </a>
      </div>

      <mat-divider class="divider"></mat-divider>

      <div class="panel-footer">
        <!-- Montant des Taxes -->
        <ng-container *ngIf="order?.price.fees">
          <div class="container-panel-info" *ngIf="order?.customCode">
            <div class="panel-label">{{ 'product.prices.fees' | translate }}</div>
            <div class="panel-data">{{ order?.price.fees }}{{ order?.price.unit }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="order?.price.taxes.length > 0">
          <div class="container-panel-info" *ngIf="order?.customCode">
            <div class="panel-label">{{ 'product.prices.taxes' | translate }}</div>
            <div class="panel-data">{{ order?.price.taxes.join(order?.price.unit + '; ') + order?.price.unit }}</div>
          </div>
        </ng-container>

        <!-- Montant brut -->
        <ng-container *ngIf="order?.price.total">
          <div class="container-price">
            <dt>{{ 'product.prices.gross' | translate }}</dt>
            <dd>
              <span class="price">{{ order?.price.total }} {{ order?.price.unit }} {{ 'product.prices.exclVAT' | translate }}</span>
            </dd>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Franco unique -->
    <div class="ctn-franco" *ngIf="this.contextService.fullContext?.customer?.isFrancoUnique">
      <div>
        <div class="ctn-franco-label">
          le franco unique
        </div>
        <div class="ctn-franco-footer">
          <div >
            <a class="btn btn-rounded"
            [class]="contextService.isVitafrais() ? 'btn btn-rounded ctn-btn-vtf btn-pronatura' : 'btn btn-rounded ctn-btn-vtf btn-vitafrais'"
            (click)="setCompany(contextService.context.companyCode == 'PRONATURAFRANCE' ? 'VITAFRAIS' : 'PRONATURAFRANCE')">
              <span class="chevron">></span> Je commande chez
              <span *ngIf="this.contextService.fullContext?.company?.code == 'PRONATURAFRANCE'"> Vitafrais</span>
              <span *ngIf="this.contextService.fullContext?.company?.code == 'VITAFRAIS'"> Pronatura</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div class="column col-9 col-2x-9 col-lg-12 col-xs-12 order-lines">
    <!-- Commentaire en haut du tableau -->
    <div class="comment">
      <p class="text-center" [innerHTML]="order?.headerComment | safeHtml"></p>
    </div>

    <!-- Tableau des produits -->
    <ng-container *ngIf="order?.lines.length > 0; else emptyOrder">
      <div class="banner" id="lines">
        <span class="h5">{{ 'order.productLabel' | translate }}</span>
      </div>
      <ngx-datatable appScrollOnPageChange anchor="lines" *ngIf="!isMobile" class="organic-alliance hoverable striped"
                    [rows]="order?.lines" [columnMode]="'flex'" [columns]="orderLinesColumns" [rowHeight]="'auto'"
                    [headerHeight]="'auto'" [footerHeight]="50" [reorderable]="false" [rowClass]="getRowClass">
      </ngx-datatable>

      <!-- Mobile display -->
      <app-history-mobile-list *ngIf="isMobile" [objects]="order?.lines" [properties]="properties" [limit]="limit"
                                  [titleTemplate]="titleTemplate" [actionTemplate]="quantityTemplate" labelProperty="productCode">
      </app-history-mobile-list>
    </ng-container>

    <!-- Commentaire en bas du tableau -->
    <div class="comment">
      <p *ngIf="order?.footerComment" class="text-center" [innerHTML]="order?.footerComment | safeHtml"></p>
    </div>
  </div>
</div>
</div>

<ng-template #emptyOrder>
  <div class="empty">
    <div class="empty-icon">
      <i class="icon icon-receipt"></i>
    </div>
    <p class="empty-title h5">{{ 'order.emptyTitle' | translate }}</p>
    <p class="empty-subtitle">{{ 'order.emptySubtitle' | translate }}</p>
    <div class="empty-action">
      <a [routerLink]="'/offers'" class="btn btn-primary">{{ 'buttons.offersLink' | translate }}</a>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="order?.outOfStockLines.length > 0">
  <div class="banner error" id="outOfStockLines">
    <span class="h5"><i class="fa fa-exclamation-triangle"></i>
      {{ 'order.productLabelOutOfStock' | translate }}</span>
  </div>
  <ngx-datatable appScrollOnPageChange anchor="outOfStockLines" *ngIf="!isMobile"
    class="organic-alliance hoverable striped error-list" [rows]="order?.outOfStockLines" [columnMode]="'flex'"
    [columns]="outOfStockColumns" [rowHeight]="'auto'" [headerHeight]="'auto'" [footerHeight]="50"
    [reorderable]="false">
  </ngx-datatable>

  <!-- Mobile display -->
  <app-history-mobile-list *ngIf="isMobile" [objects]="order?.outOfStockLines" [properties]="properties" [limit]="limit"
    [titleTemplate]="titleTemplate" labelProperty="productCode" ></app-history-mobile-list>
</ng-container>

<!-- Header template -->
<ng-template #headerTemplate let-column="column" let-sort="sortFn" let-sortDir="sortDir">
  <span title="{{ column.name | translate }}" class="datatable-header-cell-label"
    (click)="sort.call($event, sortDir, sortFn)">{{
    column.name | translate }}</span>
</ng-template>

<!-- Image template
  CLA le 30/01/2019, ajout de l'image en passant la première image de la liste
  utilisation d'un composant spécifique pour s'adapter suivant l'utilisation.
-->
<ng-template #productImageTemplate let-row="row">
  <div *ngIf="row.pictures">
    <app-product-picture [picture]="row.pictures[0]" [productCode]="row.productCode"></app-product-picture>
  </div>
</ng-template>

<!-- Discount template -->
<ng-template #priceTemplate let-row="row">
  <ng-container *ngIf="row.discount">
    {{ row.discount + row.price.unit }}
  </ng-container>
</ng-template>

<!-- Discount template -->
<ng-template #discountTemplate let-row="row">
  <div class="datatable-body-cell-label-content">
    <ul class="block">
      <li *ngFor="let d of row.price?.discounts">{{ d }}</li>
    </ul>
  </div>
</ng-template>

<!-- title template -->
<ng-template #titleTemplate let-row="row">
  <a class="title h6" title="{{ row.code }}" [routerLink]="['/product', row.productCode ]">
    {{ row.label }}
  </a>
</ng-template>

<!-- Brand template -->
<ng-template #brandTemplate let-row="row">
  <a *ngIf="row.brandUrl" href="{{ row.brandUrl }}" target="_blank">{{ row.brand }}</a>
  <span *ngIf="!row.brandUrl">{{ row.brand }}</span>
</ng-template>

<!-- Product template -->
<ng-template #productTemplate let-row="row" let-value="value">
  <a [routerLink]="['/product', row.productCode ]" target="_blank">{{ value | codeProduitSuffix:row.isDateCourte}}</a>
</ng-template>

<!-- Price by weight template -->
<ng-template #priceByWeightTemplate let-row="row">
  <ul class="block">
      <li *ngIf="row.price?.netByWeight">{{ row.price.netByWeight + row.price.unit + '/' + row.price.weightUnit }} {{ 'product.prices.netShort' |
      translate }}</li>
      <li *ngIf="row.price?.grossByWeight && !row.price?.netByWeight">{{ row.price.grossByWeight + row.price.unit + '/' + row.price.weightUnit}} {{ 'product.prices.grossShort' |
      translate }}</li>
  
  </ul>
</ng-template>

<!-- Price unit template -->
<ng-template #priceUnitTemplate let-row="row">
  <ul class="block">
    <li *ngIf="row.price?.gross">{{ row.price.gross + row.price.unit }} {{ 'product.prices.grossShort' | translate }}
    </li>
    <li *ngIf="row.price?.net">{{ row.price.net + row.price.unit }} {{ 'product.prices.netShort' | translate }}</li>
  </ul>
</ng-template>

<!-- Price total template-->
<ng-template #priceTotalTemplate let-row="row">
  <ul class="block">
    <li *ngIf="row.price?.total">{{ row.price.total + row.price.unit }} {{ 'product.prices.exclVAT' | translate }}
    </li>
    <li *ngIf="row.price?.totalAfterTaxes">{{ row.price.totalAfterTaxes + row.price.unit }}
      {{ 'product.prices.inclVAT' | translate }}</li>
  </ul>
</ng-template>

<!-- Label template -->
<ng-template #labelTemplate let-row="row">
  <div class="datatable-body-cell-label-content label-template text-left">
    <a [routerLink]="['/product', row.productCode ]">{{ row.label | capitalizeFirstLetter }}</a>
    <app-tag-label *ngFor="let tag of row.tags" [tag]="tag"></app-tag-label>
  </div>
</ng-template>

<!-- EAN template -->
<ng-template #eanTemplate let-row="row">
  <a [routerLink]="['/product', row.productCode ]" target="_blank">{{ row.ean }}</a>
</ng-template>

<!-- Date courte template -->
<ng-template #dateCourteTemplate let-row="row">
  <app-picto *ngIf="row.pictos?.length" [picto]="row.pictos[0]"></app-picto>
</ng-template>

<!-- Weight template -->
<ng-template #weightTemplate let-row="row">
  <ul class="block">
    <li *ngIf="row.weight.net">{{ row.weight.net + row.weight.unit }} {{ 'product.weights.netShort' | translate }}
    </li>
    <li *ngIf="row.weight.gross && !row.weight.net">{{ row.weight.gross + row.weight.unit }}
      {{ 'product.weights.grossShort' | translate }}
    </li>
  </ul>
</ng-template>

<!-- Quantité -->
<ng-template #quantityTemplate let-row="row">
  <div class="datatable-body-cell-label-content label-template text-center">
    <app-availability [product]="row" [productCode]="row.productCode" [outer]="row.outer"
                      [unpackedQuantity]="row.unpackedQuantity" [showStockIndicator]="false"></app-availability>
  </div>
</ng-template>
